import { gql } from '@apollo/client';

export const CONNECT_WHATSAPP = gql`
  mutation ConnectWhatsApp($input: WhatsAppConnectInput!) {
    connectWhatsApp(input: $input) {
      id
      phoneNumber
      displayName
      isActive
      phoneNumberId
      businessAccountId
      messagesCount
      createdAt
    }
  }
`;

export const DISCONNECT_WHATSAPP = gql`
  mutation DisconnectWhatsApp {
    disconnectWhatsApp
  }
`;

export const SEND_WHATSAPP_OFFER = gql`
  mutation SendWhatsAppOffer($input: WhatsAppSendOfferInput!) {
    sendWhatsAppOffer(input: $input) {
      success
      messageId
      waMessageId
      error
    }
  }
`;

export const SEND_WHATSAPP_BULK = gql`
  mutation SendWhatsAppBulk($input: WhatsAppSendBulkInput!) {
    sendWhatsAppBulk(input: $input) {
      success
      waMessageId
      error
    }
  }
`;

export const CREATE_WHATSAPP_TEMPLATE = gql`
  mutation CreateWhatsAppTemplate($input: WhatsAppTemplateInput!) {
    createWhatsAppTemplate(input: $input) {
      id
      name
      language
      content
      variables
      isDefault
      createdAt
    }
  }
`;

export const UPDATE_WHATSAPP_TEMPLATE = gql`
  mutation UpdateWhatsAppTemplate($id: Int!, $input: WhatsAppTemplateInput!) {
    updateWhatsAppTemplate(id: $id, input: $input) {
      id
      name
      language
      content
      variables
      isDefault
      createdAt
    }
  }
`;

export const DELETE_WHATSAPP_TEMPLATE = gql`
  mutation DeleteWhatsAppTemplate($id: Int!) {
    deleteWhatsAppTemplate(id: $id)
  }
`;
